import React, { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Select } from '@/src/components/Antd';
import {
  getCurrencyListSelector,
  currentPrimaryCurrencyCode,
} from 'src/constrains/SalesChannelMultiCurrencySelect/slice';
import { useGetPageCurrencyList } from 'src/constrains/SalesChannelMultiCurrencySelect/hooks';

type Props = {
  salesChannelUuid: string;
  disabled?: boolean;
  onChange?: (value: any) => void;
  value?: string;
};

/**
 * 通用 Applicable Currency 选择组件
 * 依赖 redux currency slice, 如列表为空会自动触发拉取
 */
const ApplicableCurrencySelect: React.FC<Props> = ({
  salesChannelUuid,
  disabled,
  onChange,
  value,
}) => {
  // 触发列表拉取（内部已 dispatch）
  useGetPageCurrencyList(salesChannelUuid);
  const primaryCurrency = useSelector(currentPrimaryCurrencyCode());
  const currencyList = useSelector(getCurrencyListSelector());

  const options = useMemo(() => {
    return (currencyList || []).map((i) => ({
      value: i.currencyCode,
      label: i.currencyCode,
    }));
  }, [currencyList]);

  useEffect(() => {
    if (
      !salesChannelUuid ||
      value ||
      options.length === 0 ||
      currencyList[0]?.salesChannelUuid !== salesChannelUuid
    ) {
      return;
    }

    const defaultValue =
      primaryCurrency && options.some((opt) => opt.value === primaryCurrency)
        ? primaryCurrency
        : options[0].value;
    onChange?.(defaultValue);
  }, [
    salesChannelUuid,
    value,
    options,
    currencyList,
    primaryCurrency,
    onChange,
  ]);
  return (
    <Select
      size='large'
      optionsList={options}
      disabled={disabled || options.length === 1}
      value={value}
      onChange={(value) => {
        if (onChange) onChange(value);
      }}
    />
  );
};

export default ApplicableCurrencySelect;
